import React from "react";
import Marquee from "react-fast-marquee";
import { Quote } from "lucide-react";
import { Reveal, Label } from "./anim";
import { TESTIMONIALS } from "../data/content";

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="relative bg-[#E7E2D2] py-20 md:py-28 overflow-hidden border-t border-[#16281C]/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 mb-12">
        <Reveal>
          <Label>What Clients Say</Label>
          <h2 className="mt-6 font-display font-semibold uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-[0.95] max-w-3xl text-[#16281C]">
            Approvals earned, relationships kept.
          </h2>
        </Reveal>
      </div>

      <Marquee speed={40} pauseOnHover gradient gradientColor="#E7E2D2" gradientWidth={120} autoFill>
        {TESTIMONIALS.map((t, i) => (
          <figure
            key={i}
            data-testid={`testimonial-card-${i}`}
            className="mx-4 w-[340px] md:w-[420px] shrink-0 bg-[#FAF8F1] border border-[#16281C]/12 p-8 md:p-10 flex flex-col justify-between hover:border-[#2C5F3A]/40 transition-colors"
          >
            <Quote size={28} className="text-[#2C5F3A] shrink-0" strokeWidth={1.5} />
            <blockquote className="mt-5 font-body text-base md:text-lg text-[#2A3A2E] leading-relaxed">
              "{t.quote}"
            </blockquote>
            <figcaption className="mt-8 pt-5 border-t border-[#16281C]/12">
              <p className="font-display font-semibold text-lg tracking-tight text-[#16281C]">{t.name}</p>
              <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#66766A] mt-1">{t.role}</p>
            </figcaption>
          </figure>
        ))}
      </Marquee>
    </section>
  );
};
